const stringFromStringOrArray = (value) =>
  Array.isArray(value) ? value[0] : value;

const genderString = (gender) => {
  let g = gender;
  if (Array.isArray(gender)) {
    if (gender.length > 0) {
      g = JSON.stringify(gender);
    }
    g = gender[0];
  }

  return g;
};

const productSummaryTransform = (productSummary) => {
  return {
    activity: productSummary?.activity,
    "all-ancestors-display-name": productSummary?.allAncestorsDisplayName,
    "all-ancestors-repository-id": productSummary?.allAncestorsRepositoryId,
    "all-available-sizes": productSummary?.allAvailableSizes,
    "bazaar-voice-id": productSummary?.bazaarVoiceID,
    collections: productSummary?.collections,
    "color-group": productSummary?.colorGroup?.map((cg) => {
      const [name, url] = cg?.split("|");
      return { name, url };
    }),
    colour: productSummary?.colour,
    "common-id": productSummary?.commonId,
    "currency-code": productSummary?.currencyCode,
    "default-parent-category": productSummary?.defaultParentCategory,
    "default-sku": productSummary?.defaultSku,
    "display-ca": productSummary?.displayCA,
    "display-name-with-br": productSummary?.displayNameWithBr,
    "display-name": productSummary?.displayName,
    display: productSummary?.display,
    "f5-bckimg-url": productSummary?.f5BckimgUrl,
    "free-return-shipping": productSummary?.freeReturnShipping,
    gender: genderString(productSummary?.gender ?? []),
    "has-linked-products": productSummary?.hasLinkedProducts,
    "image-scheme": productSummary?.imageScheme,
    "is-displayable": productSummary?.display,
    "is-final-sale": productSummary?.isFinalSale,
    "is-sold-out": productSummary?.isSoldOut,
    isProductLocaleMatch: productSummary?.isProductLocaleMatch,
    "item-type": productSummary?.itemType,
    "linked-products": productSummary?.linkedProducts,
    "list-price": productSummary?.listPrice,
    locale: productSummary?.locale,
    "loyalty-terms-and-conditions": productSummary?.loyaltyTermsAndConditions,
    "parent-category-display-name": productSummary?.parentCategoryDisplayName,
    "parent-category-keywords": productSummary?.parentCategoryKeywords,
    "parent-category-unified-id": productSummary?.parentCategoryUnifiedId,
    "pdp-url": productSummary?.pdpUrl,
    "price-range": productSummary?.priceRange,
    price: productSummary?.price,
    "product-activity-id-repository-id":
      productSummary?.productActivityIdRepositoryId,
    "product-applicable-systems": productSummary?.productApplicableSystems,
    "product-base-url": productSummary?.productBaseUrl,
    "product-catalog-id": productSummary?.productCatalogId,
    "product-category-hierarchy": "", // ??
    "product-category": productSummary?.productCategory,
    "product-default-sort": productSummary?.productDefaultSort,
    "product-disallow-as-recommendation":
      productSummary?.productDisallowAsRecommendation,
    "product-has-outfit-product": productSummary?.productHasOutfitProduct,
    "product-id": productSummary?.productId,
    "product-language": productSummary?.productLanguage,
    "product-last-sku-addition-date-time":
      productSummary?.productLastSkuAdditionDateTime,
    "product-mark-down": productSummary?.productMarkDown,
    "product-name": stringFromStringOrArray(productSummary?.productName),
    "product-no-follow": productSummary?.productNoFollow,
    "product-no-index": productSummary?.productNoIndex,
    "product-non-returnable": productSummary?.productNonReturnable,
    "product-number-of-image-assets": stringFromStringOrArray(
      productSummary?.productNumberOfImageAssets
    ),
    "product-on-sale": stringFromStringOrArray(productSummary?.productOnSale),
    "product-silver": productSummary?.productSilver,
    "product-site-id": "",
    "product-site-map-pdp-url": stringFromStringOrArray(
      productSummary?.productSiteMapPdpUrl
    ),
    "product-sizes": productSummary?.productSizes,
    "product-whats-new": productSummary?.productWhatsNew,
    "repository-id": "",
    "sku-on-sale": productSummary?.skuOnSale,
    "sku-sku-images": productSummary?.skuSkuImages,
    "sku-style-number":
      productSummary?.skuStyleOrder?.map?.(
        (stylOrder) => stylOrder?.split?.("|")[1]
      ) ?? [],
    "sku-style-order": productSummary?.skuStyleOrder,
    title: productSummary?.title,
    type: productSummary?.type,
    "unified-id": productSummary?.unifiedId,
    "why-we-made-this": productSummary?.whyWeMadeThis,
  };
};

export default productSummaryTransform;
